import { Provider } from '@repo/api-gw-sdk';

const awsRegions: Record<string, { displayName: string }> = {
  'us-east-1': { displayName: 'US East (N. Virginia)' },
  'us-east-2': { displayName: 'US East (Ohio)' },
  'us-west-1': { displayName: 'US West (N. California)' },
  'us-west-2': { displayName: 'US West (Oregon)' },
  'ca-central-1': { displayName: 'Canada (Central)' },
  'us-gov-east-1': { displayName: 'AWS GovCloud (US-East)' },
  'us-gov-west-1': { displayName: 'AWS GovCloud (US-West)' },
  'sa-east-1': { displayName: 'South America (São Paulo)' },
  'eu-west-1': { displayName: 'Europe (Ireland)' },
  'eu-west-2': { displayName: 'Europe (London)' },
  'eu-west-3': { displayName: 'Europe (Paris)' },
  'eu-central-1': { displayName: 'Europe (Frankfurt)' },
  'eu-central-2': { displayName: 'Europe (Zurich)' },
  'eu-south-1': { displayName: 'Europe (Milan)' },
  'eu-south-2': { displayName: 'Europe (Spain)' },
  'eu-north-1': { displayName: 'Europe (Stockholm)' },
  'ap-east-1': { displayName: 'Asia Pacific (Hong Kong)' },
  'ap-south-1': { displayName: 'Asia Pacific (Mumbai)' },
  'ap-south-2': { displayName: 'Asia Pacific (Hyderabad)' },
  'ap-southeast-1': { displayName: 'Asia Pacific (Singapore)' },
  'ap-southeast-2': { displayName: 'Asia Pacific (Sydney)' },
  'ap-southeast-3': { displayName: 'Asia Pacific (Jakarta)' },
  'ap-southeast-4': { displayName: 'Asia Pacific (Melbourne)' },
  'ap-northeast-1': { displayName: 'Asia Pacific (Tokyo)' },
  'ap-northeast-2': { displayName: 'Asia Pacific (Seoul)' },
  'ap-northeast-3': { displayName: 'Asia Pacific (Osaka)' },
  'me-south-1': { displayName: 'Middle East (Bahrain)' },
  'me-central-1': { displayName: 'Middle East (UAE)' },
  'af-south-1': { displayName: 'Africa (Cape Town)' },
  'cn-north-1': { displayName: 'China (Beijing)' },
  'cn-northwest-1': { displayName: 'China (Ningxia)' },
};

const azureRegions: Record<string, { displayName: string }> = {
  eastus: { displayName: 'East US' },
  eastus2: { displayName: 'East US 2' },
  southcentralus: { displayName: 'South Central US' },
  westus2: { displayName: 'West US 2' },
  westus3: { displayName: 'West US 3' },
  australiaeast: { displayName: 'Australia East' },
  southeastasia: { displayName: 'Southeast Asia' },
  northeurope: { displayName: 'North Europe' },
  swedencentral: { displayName: 'Sweden Central' },
  uksouth: { displayName: 'UK South' },
  westeurope: { displayName: 'West Europe' },
  centralus: { displayName: 'Central US' },
  southafricanorth: { displayName: 'South Africa North' },
  centralindia: { displayName: 'Central India' },
  eastasia: { displayName: 'East Asia' },
  japaneast: { displayName: 'Japan East' },
  koreacentral: { displayName: 'Korea Central' },
  canadacentral: { displayName: 'Canada Central' },
  francecentral: { displayName: 'France Central' },
  germanywestcentral: { displayName: 'Germany West Central' },
  italynorth: { displayName: 'Italy North' },
  norwayeast: { displayName: 'Norway East' },
  polandcentral: { displayName: 'Poland Central' },
  spaincentral: { displayName: 'Spain Central' },
  switzerlandnorth: { displayName: 'Switzerland North' },
  mexicocentral: { displayName: 'Mexico Central' },
  uaenorth: { displayName: 'UAE North' },
  brazilsouth: { displayName: 'Brazil South' },
  israelcentral: { displayName: 'Israel Central' },
  qatarcentral: { displayName: 'Qatar Central' },
  northcentralus: { displayName: 'North Central US' },
  westus: { displayName: 'West US' },
  japanwest: { displayName: 'Japan West' },
  koreasouth: { displayName: 'Korea South' },
  southindia: { displayName: 'South India' },
  westindia: { displayName: 'West India' },
  canadaeast: { displayName: 'Canada East' },
  francesouth: { displayName: 'France South' },
  germanynorth: { displayName: 'Germany North' },
  norwaywest: { displayName: 'Norway West' },
  switzerlandwest: { displayName: 'Switzerland West' },
  ukwest: { displayName: 'UK West' },
  uaecentral: { displayName: 'UAE Central' },
  brazilsoutheast: { displayName: 'Brazil Southeast' },
  australiacentral: { displayName: 'Australia Central' },
  australiacentral2: { displayName: 'Australia Central 2' },
  australiasoutheast: { displayName: 'Australia Southeast' },
  jioindiacentral: { displayName: 'Jio India Central' },
  jioindiawest: { displayName: 'Jio India West' },
  southafricawest: { displayName: 'South Africa West' },
  newzealandnorth: { displayName: 'New Zealand North' },
  newzealandsouth: { displayName: 'New Zealand South' },
};

const gcpRegions: Record<string, { displayName: string }> = {
  'us-east1': { displayName: 'Moncks Corner, South Carolina, USA' },
  'us-east4': { displayName: 'Ashburn, Virginia, USA' },
  'us-central1': { displayName: 'Council Bluffs, Iowa, USA' },
  'us-west1': { displayName: 'The Dalles, Oregon, USA' },
  'us-west2': { displayName: 'Los Angeles, California, USA' },
  'us-west3': { displayName: 'Salt Lake City, Utah, USA' },
  'us-west4': { displayName: 'Las Vegas, Nevada, USA' },
  'northamerica-northeast1': { displayName: 'Montréal, Canada' },
  'northamerica-northeast2': { displayName: 'Toronto, Canada' },
  'southamerica-east1': { displayName: 'São Paulo, Brazil' },
  'southamerica-west1': { displayName: 'Santiago, Chile' },
  'europe-west1': { displayName: 'St. Ghislain, Belgium' },
  'europe-west2': { displayName: 'London, UK' },
  'europe-west3': { displayName: 'Frankfurt, Germany' },
  'europe-west4': { displayName: 'Eemshaven, Netherlands' },
  'europe-west6': { displayName: 'Zürich, Switzerland' },
  'europe-central2': { displayName: 'Warsaw, Poland' },
  'europe-north1': { displayName: 'Hamina, Finland' },
  'me-west1': { displayName: 'Tel Aviv, Israel' },
  'me-central1': { displayName: 'Doha, Qatar' },
  'asia-east1': { displayName: 'Changhua County, Taiwan' },
  'asia-east2': { displayName: 'Hong Kong' },
  'asia-southeast1': { displayName: 'Jurong West, Singapore' },
  'asia-southeast2': { displayName: 'Jakarta, Indonesia' },
  'asia-south1': { displayName: 'Mumbai, India' },
  'asia-south2': { displayName: 'Delhi, India' },
  'asia-northeast1': { displayName: 'Tokyo, Japan' },
  'asia-northeast2': { displayName: 'Osaka, Japan' },
  'asia-northeast3': { displayName: 'Seoul, South Korea' },
  'australia-southeast1': { displayName: 'Sydney, Australia' },
  'australia-southeast2': { displayName: 'Melbourne, Australia' },
};

export const Regions: Record<
  Provider,
  Record<string, { displayName: string }>
> = {
  [Provider.Aws]: awsRegions,
  [Provider.Azure]: azureRegions,
  [Provider.Gcp]: gcpRegions,
  [Provider.MongoAtlas]: {},
  [Provider.ProviderUnspecified]: {},
};
